import { Candidate } from "./CandidateDashboard";
import {
  formatLeadPhone,
  leadStatusLabel,
} from "./campaignLeadHelpers";

const escapeCsvValue = (value: string | number | null | undefined): string => {
  const str = value == null ? "" : String(value);
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

const CSV_HEADERS = [
  "First Name",
  "Last Name",
  "Email",
  "Phone",
  "Job Title",
  "Status",
  "Residence",
  "LinkedIn",
  "CV URL",
  "Applied Date",
] as const;

export const exportLeadsToCsv = (
  leads: Candidate[],
  campaignName: string
): void => {
  if (!leads.length) return;

  const rows = leads.map((lead) => [
    lead.firstName,
    lead.lastName,
    lead.email,
    formatLeadPhone(lead.countryCode, lead.phone),
    lead.jobTitle,
    leadStatusLabel(lead.status),
    lead.residence || "",
    lead.linkedin || "",
    lead.cv || "",
    lead.createdAt
      ? new Date(lead.createdAt).toLocaleDateString("en-GB")
      : "",
  ]);

  const csvContent = [
    CSV_HEADERS.join(","),
    ...rows.map((row) => row.map(escapeCsvValue).join(",")),
  ].join("\r\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const safeName = (campaignName || "campaign")
    .replace(/[^\w\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .toLowerCase();
  const date = new Date().toISOString().slice(0, 10);

  link.href = url;
  link.download = `${safeName}-leads-${date}.csv`;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
